import { UAParser } from 'ua-parser-js';

const has = Object.prototype.hasOwnProperty;

export const isEmpty = (prop) => {
  return (
    prop === null ||
    prop === undefined ||
    (has.call(prop, 'length') && prop.length === 0) ||
    (prop.constructor === Object && Object.keys(prop).length === 0)
  );
};

export const checkDeviceType = () => {
  const parser = new UAParser();
  return parser.getResult();
};
